/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Bumble प्राप्त करें",
      "सभी को स्वीकार करें",
      "विकल्प प्रबंधित करें",
      "कुकी नीति",
      "वापस जाएँ",
      "ग़लत फोन क्रमांक",
      "© {{current_year}} Bumble | सभी अधिकार सुरक्षित हैं",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble डेट",
      "हमारे बारे में",
      "एम्बेसडर",
      "The Buzz",
      "हम कुकीज़ का उपयोग कर रहे हैं। यदि आप अपनी सेटिंग्स को समायोजित नहीं करते तो हम मानते हैं कि आप को इस से कोई परेशानी नहीं है।",
      "ऐप डाउनलोड करें",
      "Android के लिए डाउनलोड करें",
      "iOS के लिए डाउनलोड करें",
      "हमें खेद है, पर आप जिस पेज को खोज रहे हैं हम उसे खोज नहीं सके हैं।",
      "साइन इन करें",
      "शामिल हो जाएँ",
      "समुदाय में शामिल हों!",
      "अरे रे! कुछ गड़बड़ हो गई है"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "दिन",
                  "दिनों"
            ],
            "singular": [
                  "दिन",
                  "दिन"
            ]
      },
      "hour": {
            "plural": [
                  "घंटे",
                  "घंटे"
            ],
            "singular": [
                  "घंटे",
                  "घंटे"
            ]
      },
      "minute": {
            "plural": [
                  "मिनट",
                  "मिनटों"
            ],
            "singular": [
                  "मिनट",
                  "मिनट"
            ]
      },
      "month": {
            "plural": [
                  "महीने",
                  "महीनों"
            ],
            "singular": [
                  "महीना",
                  "महीना"
            ]
      },
      "second": {
            "plural": [
                  "सेकंड",
                  "सेकंड"
            ],
            "singular": [
                  "सेकंड",
                  "सेकंड"
            ]
      },
      "year": {
            "plural": [
                  "साल",
                  "सालों"
            ],
            "singular": [
                  "साल",
                  "साल"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
